import { Helpers } from '@utils/helpers';
import { get } from 'lodash';

export class AboutYouForm {
  duties: string | undefined;
  nature: string | undefined;
  otherBusiness: string | undefined;
  fund: string[] | undefined;
  otherFund: string | undefined;
  wealth: string[] | undefined;
  otherWealth: string | undefined;
  income: number | undefined;

  constructor(initial: any) {
    this.duties = get(initial, 'duties', undefined);
    this.nature = get(initial, 'nature', undefined);
    this.otherBusiness = get(initial, 'otherBusiness', undefined);
    this.otherFund = get(initial, 'otherFund', undefined);
    this.wealth = get(initial, 'wealth', undefined);
    this.fund = get(initial, 'fund', undefined);

    this.otherWealth = get(initial, 'otherWealth', undefined);
    this.income = get(initial, 'income', undefined);
  }

  get reviewIncome(): { text: string, value: any }[] {
    const nature = this.nature === '12' ? this.otherBusiness : Helpers.getNatureByCode(this.nature || '');
    return [
      { text: 'Exact duties of occupation', value: this.duties },
      { text: "Nature of employer's business", value: nature || '' },
      this.sourceOfFunds,
      this.sourceOfWealths,
      { text: "Annual income", value: Helpers.toCurrency(Number(this.income)) },

    ]
  }

  get sourceOfFunds(): { text: string, value: any } {
    const funds = this.fund || [];
    return {
      text: 'Please select your source of funds (Origin of the funds used to pay your premiums',
      value: funds.map(item => {
        if(item === 'other') {
          return this.otherFund;
        }
        return Helpers.getSourceByCode(item, 'fund');
      })
    }
  } 
  get sourceOfWealths(): { text: string, value: any } {
    const wealth = this.wealth || [];
    return {
      text: 'Please select your source of wealth (Where your wealth is derived from)',
      value: wealth.map(item => {
        if(item === 'other') {
          return this.otherWealth;
        }
        return Helpers.getSourceByCode(item, 'wealth');
      })
    }
  }
}

export class AboutYouHealthForm {
  gender:  string | undefined;
  isSmoker: boolean | undefined;
  lessThan40Sticks: string | undefined;
  height: number | undefined;
  weight: number | undefined;
  q1: string | undefined;
  q2: string | undefined;
  q3: string | undefined;
  q4: string | undefined;
  q5: string | undefined;
  q6: string | undefined;
  q7: string | undefined;
  q8: string | undefined;
  q9: string | undefined;
  q10: string | undefined;
  q11: string | undefined;
  q12: string | undefined;
  constructor(initial: any) {
    this.gender = get(initial, 'gender', undefined);
    this.isSmoker = get(initial, 'isSmoker', true);
    this.height = get(initial, 'height', undefined);
    this.weight = get(initial, 'weight', undefined);
    this.lessThan40Sticks = get(initial, 'lessThan40Sticks', undefined);
    this.q1 =  get(initial, 'q1', undefined);
    this.q2 =  get(initial, 'q2', undefined);
    this.q3 =  get(initial, 'q3', undefined);
    this.q4 =  get(initial, 'q4', undefined);
    this.q5 =  get(initial, 'q5', undefined);
    this.q6 =  get(initial, 'q6', undefined);
    this.q7 =  get(initial, 'q7', undefined);
    this.q8 =  get(initial, 'q8', undefined);
    this.q9 =  get(initial, 'q9', undefined);
    this.q10 =  get(initial, 'q10', undefined);
    this.q11 =  get(initial, 'q11', undefined);
    this.q12 =  get(initial, 'q12', undefined);
  }
  get reviewHealth(): any {  
    const listing: any[] = [
      {
        text: 'Do you take part in or plan to participate in any of the following activities:',
        children: [],
        value: this.getValue(this.q1)
      },
      {
        text: 'In the last 12 months, have you spent more than 90 days outside of your current country of residence (excluding holiday or leisure)?',
        value: this.getValue(this.q2)
      },
      {
        text: 'In the next 12 months, do you plan to spend more than 90 days outside of your current country of residence (excluding holiday or leisure)?',
        value: this.getValue(this.q3)
      },
    ];

    if (this.isSmoker) {
      listing.push(
        { text: 'How many sticks do you smoke daily?', value: this.lessThan40Sticks === 'Y' ? 'Less than 40 sticks' : '40 sticks and above' }
      );
    }

    listing.push(
      { text: 'Do you drink more than 20 standard alcohol drinks per week?', value: this.getValue(this.q4) },
      { text: 'Have you ever taken or used addictive or illegal drugs, or been treated for drug addiction or alcoholism?', value: this.getValue(this.q5) },
      { text: 'Do you have a regular doctor?', value: this.getValue(this.q6) },
      { text: 'Have you experienced symptoms or received medical advice or had treatment for any of the following conditions (whether diagnosed or not)?',
        value: this.getValue(this.q7),
        children: [
          'Heart attack, chest pain or discomfort, irregular heart beat, heart valve disorder, heart murmur, palpitations or any other blood vessel or heart disease or disorder',
          'High blood pressure or high cholesterol',
          'Cancer, tumour, cyst, lump or growth of any kind including cancer screening tests that were not normal',
          'Diabetes, elevated or raised blood sugar, thyroid disorders or any other endocrine disease or disorder',
          'Asthma, bronchitis, pneumonia, tuberculosis, emphysema or any other breathing or lung disease or disorder',
          'Depression, anxiety, stress or any other mental or nervous disorder',
          'Arthritis, gout or any other disorder, pain or injury to the muscles, bones, tendons, limbs, joints, spine (back or neck)',
          'Stroke, epilepsy, fits, paralysis or weakness of limb, head injury or any other neurological disease or disorder',
          "Crohn's disease, ulcerative colitis, gastritis, stomach or duodenal ulcers, blood in stools or any other bowel, stomach or intestinal disease or disorder",
          'Hepatitis B or C, fatty liver, abnormal or elevated liver function, gallstones or any other liver or gallbladder disease or disorder',
          'Anaemia, thalassaemia, haemophilia or any other blood disease or disorder',
          'Kidney stones, kidney infection, urine abnormalities or any other kidney, bladder, prostate or gynaecological disease or disorder',
          'Eye, ear, nose or throat disease or disorder (excluding sight problems corrected by prescription lenses)',
          'Any other illness, disorder, operation, physical disability or injury not mentioned above'
        ],
      },
      { text: 'Other than the conditions that you have already told us about, in the last 5 years have you had any abnormal medical test result from medical test(s) such as X-ray, ultrasound, imaging scan, biopsy, electrocardiogram (ECG), HIV test, blood or urine test, Covid-19 PCR, pap smear or mammogram?', value: this.getValue(this.q8) },
      { text: 'Other than the conditions that you have already told us about, are you currently experiencing symptoms or considering seeking medical advice or treatment for your health other than minor illnesses such as cold or flu?', value: this.getValue(this.q9) },
      { 
        text: 'Has any of your natural parent or sibling been diagnosed with or died from any of the following before age 60?',
        value: this.getValue(this.q10),
        children: [
          'Cancers of the bowel, colon, breast or ovary',
          'Diabetes mellitus',
          'Cardiomyopathy, coronary artery disease, heart attack, ischaemic heart disease, stroke',
          'Multiple Sclerosis, muscular dystrophy',
          "Alzheimer's disease, Huntington's disease, Parkinson's Disease",
          'Polycystic kidney disease',
          'Any other hereditary disease or disorder requiring regular consultation'
        ]
      },
      { text: 'Have you or your spouse or partner been told to have, received any medical advice, counselling or treatment in connection with sexually transmitted disease, AIDS, AIDS related complex or any other AIDS related condition?', value: this.getValue(this.q11) },
      this.gender === 'F' && { text: 'Are you currently pregnant?', value: this.getValue(this.q12) },

    )

    return listing.filter(o => o!== null);
  }

  private getValue(is: string | undefined): string {
    return is === 'Y' ? 'Yes' : 'No';
  }
}